import React from "react"
import { Modal, Form, Col, Row, Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { GetParameterType, ParameterTypeUpdate} from "../../api/Administration/ParameterType"
import ParameterTypeData from "../../api/Administration/Model/ParameterTypeData"
import ActionButton from "../ActionButton"

interface ParameterTypeModalProps {
  show:boolean
  LoginName:string
  onCancel: () => void
  onSubmit: (parameterType: string, parameterTypeDescription: string) => void
}

interface ParameterTypeModalState {
  parameterTypeID: number
  parameterType: string
  parameterTypeDescription: string
  isTypeValid:boolean
  isDescriptionValid:boolean
  dataLoading:boolean
  dataLoaded:boolean
  dataSaving:boolean

}

export default class ParameterTypeModal extends React.PureComponent<ParameterTypeModalProps, ParameterTypeModalState> {
  
  emptyState: ParameterTypeModalState = {
    parameterTypeID:0,
    parameterType: "",
    parameterTypeDescription: "",
    isTypeValid:false,
    isDescriptionValid:false,
    dataLoading:false,
    dataLoaded:false,
    dataSaving:false
  }
  state: ParameterTypeModalState = { ...this.emptyState }
  subscription?: Subscription
  saveSubscription?: Subscription

  componentDidUpdate(prevProps: ParameterTypeModalProps) {
    //if (this.props.show && this.props.show !== prevProps.show) {
      //this.loadSubscriptionPlans()
    //}
  }

  componentWillUnmount() {
    this.subscription && this.subscription.unsubscribe()
    this.saveSubscription && this.saveSubscription.unsubscribe()
  }
  handleTypeChange = ( value: string) => {
    this.setState(
      { 
        parameterType: value, 
        isTypeValid: this.isTypeValid(value),
        parameterTypeDescription: "",
        isDescriptionValid: this.isDescriptionValid(""),
        dataLoaded:false
        
    }) 
  }
  handleDescriptionChange = ( value: string) => {
    this.setState(
      { 
        parameterTypeDescription: value,
        isDescriptionValid: this.isDescriptionValid(value) 
      })
  }
  isTypeValid = (value: string) => {
    if (value.length < 1) {
      return false
    }
    return true;
  }
  isDescriptionValid = (value: string) => {
    if (value.length < 1) {
      return false
    }
    return true;
  }
  handleRetrieve = () => {
    this.setState({ dataLoading: true, dataLoaded:false })
    const { parameterType } = this.state

      this.subscription = GetParameterType(parameterType).subscribe(
        (data: ParameterTypeData) => {
          this.setState({ 
            parameterTypeID: data.ParameterTypeID,
            parameterType:  data.ParameterType,
            parameterTypeDescription:  data.ParameterTypeDescription,
            isTypeValid: this.isTypeValid(data.ParameterType),
            isDescriptionValid: this.isDescriptionValid(data.ParameterTypeDescription),
            dataLoading: false, 
            dataLoaded:true
          })
        },
        (error) => {
          toast.error(error?.errorData?.message || error.message)
          this.setState({ dataLoading: false,dataLoaded:true })
        },
        () => {
          this.setState({ dataLoading: false, dataLoaded:true })
        }
      )
  }

  handleSubmit = () => {
    this.setState({ dataSaving: true, dataLoading:false })
    const updateData = this.stateToData()
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = ParameterTypeUpdate(updateData).subscribe(
      data => {
        this.setState({ dataSaving: false })
        toast.success(data),
        this.onSubmit()
      },
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ dataSaving: false })
      },
      () => {
        this.setState({ dataSaving: false })
      }
    )

  }

  loadSubscriptionPlans = () => {
    this.setState({ dataLoading: true })
    /*
    this.subscription = GetSubscriptionPlans().subscribe(
      (data: SubscriptionPlan[]) => this.setState({ loading: false, availableSubscriptionPlans: data }),
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ loading: false })
      },
      () => this.setState({ loading: false })
    )
    */
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onSubmit = () => {
    this.props.onSubmit(this.state.parameterType, this.state.parameterTypeDescription)
  }
  render() {

    const {parameterType, parameterTypeDescription, isTypeValid, isDescriptionValid, dataLoading, dataLoaded, dataSaving} = this.state
    //const currentPlan: SubscriptionPlan = availableSubscriptionPlans.filter((plan: SubscriptionPlan) => plan.SubscriptionPlanID === this.props.subscriptionPlanID)[0]
    return (
      <>
        <Modal backdrop="static" show={ this.props.show } size="lg" dialogClassName="dark">
          <Modal.Header>
            <Modal.Title className="text-uppercase">ADD / EDIT DATA TYPE</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form >
            <Form.Row className="form-group required">
              <Form.Label column lg={2} htmlFor="parameterType">Type</Form.Label>
              <Col lg={7}>
                  <Form.Control 
                  id="parameterType" 
                  className="bg-white" 
                  type="text" 
                  maxLength={1}
                  value={this.state.parameterType} 
                  onChange={e => this.handleTypeChange(e.target.value)}
                  />
              </Col>
              <Col lg={2}>
                <ActionButton variant="secondary" onClick={this.handleRetrieve} disabled={dataLoading || dataSaving || !isTypeValid} spin={dataLoading} disableOnSpin>Retrieve</ActionButton>
              </Col>
            </Form.Row>
          <Form.Row className="form-group required">
              <Form.Label column lg={2} htmlFor="parameterDescription">Description</Form.Label>
              <Col lg={7}>
                  <Form.Control 
                  id="parameterDescription" 
                  className="bg-white"  
                  as="textarea" 
                  rows={3} 
                  maxLength={25}
                  value={this.state.parameterTypeDescription} 
                  onChange={e => this.handleDescriptionChange(e.target.value)}
                  disabled={ dataLoading || dataSaving || !isTypeValid || !dataLoaded}
                  />
              </Col>
              <Col lg={2}>
              </Col>
            </Form.Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <ActionButton 
            variant="primary" 
            onClick={ this.handleSubmit } 
            disabled={ dataLoading || dataSaving || !isTypeValid || !isDescriptionValid} spin={ dataSaving } disableOnSpin>Submit</ActionButton>
            <Button variant="secondary" onClick={ this.onCancel } className="px-4">Cancel</Button>
          </Modal.Footer>
        </Modal>
      </>
    )
    }
    
    stateToData():ParameterTypeData {
      return {
        ParameterTypeID: this.state.parameterTypeID,
        ParameterType: this.state.parameterType,
        ParameterTypeDescription: this.state.parameterTypeDescription,
        CreatedBy: this.props.LoginName,
        ModifiedBy: this.props.LoginName
      }
    }
  
  
}
